import { cn } from "@/lib/utils"

type QuanticaLogoProps = {
  className?: string
  markClassName?: string
  wordmarkClassName?: string
  compact?: boolean
}

export function QuanticaMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 128 128"
      role="img"
      aria-label="Símbolo da Quântica Consultoria"
      className={cn("h-12 w-12 shrink-0", className)}
    >
      <title>Símbolo da Quântica Consultoria</title>
      <defs>
        <linearGradient id="quantica-blue" x1="18" y1="6" x2="104" y2="120">
          <stop offset="0" stopColor="#30349a" />
          <stop offset="0.58" stopColor="#34328f" />
          <stop offset="1" stopColor="#433475" />
        </linearGradient>
        <linearGradient id="quantica-orange" x1="28" y1="10" x2="102" y2="118">
          <stop offset="0" stopColor="#ff8f1d" />
          <stop offset="0.48" stopColor="#ff7f1e" />
          <stop offset="1" stopColor="#f08a00" />
        </linearGradient>
        <clipPath id="quantica-mark-clip">
          <circle cx="64" cy="64" r="58" />
        </clipPath>
      </defs>
      <g clipPath="url(#quantica-mark-clip)">
        <circle cx="64" cy="64" r="58" fill="url(#quantica-blue)" />
        <path
          d="M65.6 4.2v36.1c-10.7 2.2-18.8 11.7-18.8 23.1 0 9.9 6.1 18.4 14.7 21.9C39.8 82.3 23.2 64.7 23.2 43.7 23.2 21.8 41.1 6.6 65.6 4.2Z"
          fill="url(#quantica-orange)"
        />
        <path
          d="M62.4 123.8V87.7c10.7-2.2 18.8-11.7 18.8-23.1 0-9.9-6.1-18.4-14.7-21.9 21.7 3 38.3 20.6 38.3 41.6 0 21.9-17.9 37.1-42.4 39.5Z"
          fill="url(#quantica-orange)"
        />
        <path
          d="M64 0v39.8M64 88.2V128"
          stroke="#fff"
          strokeLinecap="square"
          strokeWidth="8"
        />
        <circle cx="64" cy="64" r="19.4" fill="#fff" />
      </g>
      <circle
        cx="64"
        cy="64"
        r="58"
        fill="none"
        stroke="#2f318f"
        strokeOpacity="0.14"
        strokeWidth="2"
      />
    </svg>
  )
}

export function QuanticaLogo({
  className,
  markClassName,
  wordmarkClassName,
  compact = false,
}: QuanticaLogoProps) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <QuanticaMark className={markClassName} />
      {!compact && (
        <div className={cn("leading-none", wordmarkClassName)}>
          <span className="block font-serif text-2xl font-semibold tracking-[0.08em] text-[#201936]">
            QUÂNTICA
          </span>
          <span className="mt-1 block text-[0.68rem] font-semibold uppercase tracking-[0.24em] text-[#f08a00]">
            Consultoria
          </span>
        </div>
      )}
    </div>
  )
}
